import Complement from "../composition/Complement"

export default class Track extends Complement {
    static className = "Track"

    getArticleSummary() {
        const installation = this.getAttributeVariation("installation");
        const productLength = this.getTechnicalDataByKey("productLength");

        const complementSummary = super.getArticleSummary()
        const summary = {
            ...complementSummary,
            installation: installation ?? null,
            productLength: productLength ?? null
        }
        return summary;
    }

    getArticleSummaryVariations() {
        const installations = this.getAttributeVariations("installation");
        const productLength = this.getTechnicalDataByKey("productLength");

        const complementSummary = super.getArticleSummaryVariations()
        const summaryVariations = {
            ...complementSummary,
            installations: installations ?? null,
            productLength: productLength ?? null
        }
        return summaryVariations;
    }

    getInfo() {
        const productLength = this.getTechnicalDataByKey("productLength")?.shortDescription?.['en'];

        const superComplementInfo = super.getInfo();

        const complementInfo = {
            ...superComplementInfo,
            article: {
                ...superComplementInfo.article,
                productLength,
                type: "track",
            },
            attributes: {
                ...superComplementInfo.attributes,
                productLength
            }
        };

        return complementInfo;
    }
}